import { severidadeLimite } from "../../hooks/nova-obra.duracao";
import { hojeBrasilia } from "@/modules/obras/hoje-brasilia";
import { useMemo } from "react";
import { textoRelacaoObra } from "../../hooks/nova-obra.condicoes";
import { intervaloPeriodoObra } from "../../hooks/nova-obra.duracao";
import { INFO_EMBARCACAO } from "../../nova-obra.constants";
import type { InfoLimitesClasseProps } from "./types-info-limites-classe";

/** Tooltip da tag (Figma 12401:175097): mesma contagem da coluna "Em relação à obra" do modal. */
function tooltipLimite(
  vencimento: string,
  periodo: { inicio: string; fim: string },
  hoje: string,
): string {
  const { relacao, texto } = textoRelacaoObra(vencimento, periodo, hoje);
  if (relacao === "VENCIDO") return texto;
  if (relacao === "DURANTE_A_OBRA") return INFO_EMBARCACAO.tooltipDuranteObra;
  return `Vence ${texto} da obra`;
}

export function useInfoLimitesClasse({
  info,
  dados,
  cronograma,
  catalogo,
  onVerTodos,
  maxTagsVisiveis,
}: InfoLimitesClasseProps) {
  const periodoObra = intervaloPeriodoObra(dados, cronograma, catalogo);
  const limites = info.limitesClasse;
  const compacto = maxTagsVisiveis !== undefined;
  const visiveis = compacto ? limites.slice(0, maxTagsVisiveis) : limites;
  const ocultos = limites.length - visiveis.length;
  const hoje = useMemo(() => hojeBrasilia(), []);
  // Mesmo período do modal "Ver todos" (início → término previsto), para a contagem coincidir.
  const periodoTooltip =
    cronograma.inicio && cronograma.terminoPrevisto
      ? { inicio: cronograma.inicio, fim: cronograma.terminoPrevisto }
      : null;

  return {
    periodoObra,
    limites,
    compacto,
    visiveis: visiveis.map((limite) => ({
      chave: `${limite.nome}-${limite.vencimento}`,
      nome: limite.nome,
      vencimento: limite.vencimento,
      severidade: severidadeLimite(limite, periodoObra),
      tooltip: periodoTooltip ? tooltipLimite(limite.vencimento, periodoTooltip, hoje) : undefined,
    })),
    ocultos,
    info,
    onVerTodos,
  };
}
